import { render } from "./FormCavityWallView.vue?vue&type=template&id=8cef60de"
import script from "./FormCavityWallView.vue?vue&type=script&lang=js"
export * from "./FormCavityWallView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__